import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exam-attempt-states/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const examAttemptStates = {
  getAll: apiPathFunc(pathBase),
} as const;
